export default __webpack_public_path__ + "static/media/neutralGender.5cc80795.svg";